import React, { useState, useEffect } from 'react'
import Post from "./posts/post/Post";
import Comments from "./comments/Comments";
import { Grid, Container, Paper, CircularProgress } from "@material-ui/core";
import { getSearchedPost } from "./../api/index";

const SinglePost = ({ post }) => {
    const id = window.location.pathname.substring(3);
    const [p, setP] = useState(post);

    useEffect(() => getSearchedPost(id).then(({ data }) => setP(data)), []);

    if (!p) return (
        <div style={{textAlign:"center"}}>
            <CircularProgress />
        </div>
    );

    return (
        <Container maxWidth="md">
            <Grid container alignItems="flex-start" spacing={3}>
                <Grid item xs={12} sm={6}>
                    <Post post={p} single={true} />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Paper elevation={3} style={{ padding: "10px" }}>
                        <Comments post={p} />
                    </Paper>
                </Grid>
            </Grid>
        </Container>
    )
}

export default SinglePost;